interface TitleSubtitleProps {
  title: string;
  subtitle: string;
  className?: string;
  variant?: 'small' | 'large';
  headingLevel?: 'h1' | 'h2';
}

function TitleSubtitle({ title, subtitle, className, variant = 'small', headingLevel = 'h2' }: TitleSubtitleProps) {
  const HeadingTag = headingLevel;
  const titleClasses =
    variant === 'large' ? 'mb-0 text-[1.75rem]/[1.875rem] font-extrabold' : 'leading-[32px] mb-0 text-[1.5rem]';
  const subtitleClasses =
    variant === 'large'
      ? 'text-[#525252] tracking-tight mt-0 text-[1.125rem]/[1.35rem] font-regular'
      : 'text-[#525252] tracking-tight mt-0 text-[1rem]/[1.125rem] font-regular';

  return (
    <div className={className}>
      <HeadingTag className={titleClasses}>{title}</HeadingTag>
      <p className={subtitleClasses}>{subtitle}</p>
    </div>
  );
}

export default TitleSubtitle;
